import "./social-icon-styles.scss";

const SocialIconComponent = ({ icon, link, title }) => {
	return (
		<a href={link} target="_blank" title={title} className="icon-box">
			<li className="icon">{icon}</li>
		</a>
	);
};

export default SocialIconComponent;